// extracted by mini-css-extract-plugin
export default {"root":"editProfile_root__R7Rvb","item":"editProfile_item__S7510"};